<template>
    <div class="full-wdith-editor" v-loading="loading">
        <div v-show="null == editObj">
            <CompanyAuthList
                :list="record11List"
                @clickSave="clickSaveCallback"
                @clickInsert="clickInsertCallback"
            />
        </div>

        <div v-if="null != editObj">
            <InsertOrEditCompanyAuth
                :editObj="editObj"
            />
        </div>

    </div>
</template>

<script setup>

import CompanyAuthList from "@/components/shopopee/company/auth/companyAuthList.vue";
import InsertOrEditCompanyAuth from "@/components/shopopee/company/auth/insertOrEditCompanyAuth.vue";
import {inject, ref, onBeforeMount} from "vue";
import record11Api from "@/request/record11Api";
import myUtil from "@/util/util";

const props = defineProps(["companycode"])
const i18n = inject("i18n")
const loading = ref(false)

const record11List = ref([])
const editObj = ref(null)

function getRecord11List(){
    loading.value = true

    const request = record11Api.queryAdditionalrecord11
    const params = request.getParams()

    params.companycode = props.companycode

    request.send(params, (res) => {
        loading.value = false

        if (res.code == 200){
            record11List.value = res.detail
        }else{
            myUtil.alertError(res.msg)
        }
    })

}

function clickSaveCallback(obj){
    loading.value = true

    const request = record11Api.updateAdditionalrecord11
    const params = request.getParams()

    params.id = obj.id
    params.addinfo9 = obj.addinfo9.replaceAll("-", "/")
    params.addinfo10 = obj.addinfo10.replaceAll("-", "/")
    params.addremark1 = JSON.stringify(obj.addremark1)

    request.send(params, (res) => {
        loading.value = false

        if (res.code == 200){
            myUtil.alertSuccess(i18n.tkey("lang_save_success"))
            getRecord11List()
        }else {
            myUtil.alertError(res.msg)
        }
    })

}

function clickInsertCallback(obj){
    loading.value = true

    const request = record11Api.insertAdditionalrecord11
    const params = request.getParams()

    params.companycode = props.companycode
    params.addinfo9 = obj.addinfo9.replaceAll("-", "/")
    params.addinfo10 = obj.addinfo10.replaceAll("-", "/")
    params.addremark1 = JSON.stringify(obj.addremark1)

    request.send(params, (res) => {
        loading.value = false

        if (res.code == 200){
            myUtil.alertSuccess(i18n.tkey("lang_save_success"))
            getRecord11List()
        }else {
            myUtil.alertError(res.msg)
        }
    })
}

onBeforeMount(() => {
    if (null != props.companycode){
        getRecord11List()
    }
})

</script>

<style scoped>

.full-wdith-editor {
    width: 100%;
    box-sizing: border-box;

}

</style>